export default __webpack_public_path__ + "loginImage_aga.png";